/**
* @desc    Get days difference from today's date
* @param   {String} date        String
* @return  {Number}
*/
window.getDaysDifference = function (date) {
  return Math.ceil(
    Math.abs(
      new Date(date) - new Date()
    ) / (1000 * 60 * 60 * 24)
  )
}

/**
* @desc    Get delivery label and status of item
* @param   {Object} response    return label and date property
* @return  {Object}
*/
window.getDeliveryLabel = function (conditions, qty) {
  const response = {}

  const daysDiff = window.getDaysDifference(conditions.fixedDate)

  if (conditions.isFixedDelivery && qty <= 0) {
    response.label = `在庫なし ${conditions.fixedDate}に発送`
    response.date = 'FIXED'
  } else if (conditions.isFixedDelivery && qty > 0 && daysDiff > 1) {
    response.label = `予約商品 ${conditions.fixedDate}に発送`
    response.date = 'FIXED'
  } else if (conditions.isFixedDelivery && qty > 0 && daysDiff < 2) {
    response.label = '在庫あり __DATE__に発送'
    response.date = 'IN_STOCK'
  } else if (!conditions.isFixedDelivery && qty > 0) {
    response.label = '在庫あり __DATE__に発送'
    response.date = 'IN_STOCK'
  } else if (!conditions.isAvailable && qty < 1) {
    response.label = '売り切れ'
    response.date = 'SOLD'
  } else if (conditions.isAvailable && qty < 1) {
    response.label = '受注生産商品 __DATE__に発送'
    response.date = 'PRE_ORDER'
  }

  return response
}
